import React from "react";
import { AiOutlineSearch } from "react-icons/ai";

function SearchBox({
  searchOrderName,
  setSearchOrderName,
  searchOrder,
  settings,
}) {
  return (
    <div className="flex items-center my-5 w-full">
      <input
        type="text"
        placeholder="Search with order name"
        className="px-4 py-2.5 rounded-l w-full text-sm"
        value={searchOrderName}
        onChange={(e) => setSearchOrderName(e.target.value)}
      />
      <AiOutlineSearch
        className="text-white p-2.5 text-3xl rounded-r cursor-pointer"
        style={{ background: settings["--site-widget-primary-color"] }}
        size={40}
        onClick={() => searchOrder()}
      />
    </div>
  );
}

export default SearchBox;
